<template>
  <div id="achievementApply">
    <bread :content="breadContent"></bread>
    <p class="Page-title">成果应用</p>
    <el-divider></el-divider>
    <div class="container">
      <achievementCard :data="item" v-for="(item, index) in achievementCardData" :key="index"></achievementCard>
    </div>
  </div>
</template>

<script>
import bread from "@/components/bread";
import achievementCard from "@/components/studyResult/achievementCard";
import Api from "@/network.js";

export default {
  name: "achievementApply",
  components: {
    achievementCard,
    bread
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "研究成果", routerName: "studyResult" },
        { text: "成果应用", routerName: "" }
      ],
      achievementCardData: []
    };
  },
  methods: {
    setData(obj) {
      // 将obj与this.data合并
      Object.assign(this.$data, obj);
    }
  },
  async beforeRouteEnter(to, from, next) {
    const res = (await Api.studyResult.getAchievementApply()) || [];
    next(vm => vm.setData({ achievementCardData: res }));
  }
};
</script>

<style lang="scss" scoped>
#achievementApply {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  .achievementCard {
    min-width: 200px;
    width: 25%;
    margin: 1%;
  }
}
</style>
